module.exports = {"centerPoint":{"lat":53.680299,"lng":-5.353472},"zoom":6,"fullscreenControl":false,"mapTypeControl":false,"streetViewControl":false,"zoomControl":false,"backgroundColor":"#f4fbfd"}


//////////////////
// WEBPACK FOOTER
// ./src/map-config.json
// module id = 1b0p
// module chunks = 1